import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SiteSettingsContext = createContext(null);

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);

  const load = useCallback(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => setSettings({ features: {} }));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const features = settings?.features || {};
  // A feature is enabled unless explicitly set to false (so nothing flickers while loading).
  const isEnabled = (key) => features[key] !== false;

  return (
    <SiteSettingsContext.Provider value={{ settings, features, isEnabled, ready: !!settings, refresh: load }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => useContext(SiteSettingsContext);
